import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../foundations/typography';
import { ButtonSizeType, ButtonVariantType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, TOKENS) => ({
    ...TOKENS,
    container: {
        width: '100%',
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_300,
        max_width: FOUNDATIONS.size_1238,
        // Avoid overlap with the outline ind desktop
        margin_top: FOUNDATIONS.border_100,
        padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
        ...TOKENS?.container,
        [DeviceBreakpointsType.TABLET]: {
            max_width: FOUNDATIONS.size_1225,
            ...TOKENS?.container?.TABLET,
        },
        [DeviceBreakpointsType.MOBILE]: {
            max_width: FOUNDATIONS.size_1200,
            ...TOKENS?.container?.MOBILE,
        },
        ...TOKENS.container,
    },
    illustration: {
        width: FOUNDATIONS.size_850,
        height: FOUNDATIONS.size_850,
        ...TOKENS?.illustration,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_100,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
        ...TOKENS?.title,
    },
    description: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: 'center',
        ...TOKENS?.description,
    },
    titleDescriptionContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        ...TOKENS?.titleDescriptionContainer,
    },
    button: {
        variant: ButtonVariantType.PRIMARY_GHOST,
        size: ButtonSizeType.EXTRA_SMALL,
        ...TOKENS?.button,
    },
});
//# sourceMappingURL=commonStyles.js.map